export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  excerpt: string;
  content: string;
  coverImageUrl: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  isFeatured: boolean;
  gameId: string;
  gameName: string;
}

export const articles: Article[] = [
  {
    id: 'article-001',
    title: '「原神」5.0纳塔版本全方位攻略：新角色、新地图、新机制一网打尽',
    slug: 'genshin-impact-natlan-guide',
    category: '攻略',
    categorySlug: 'guide',
    excerpt: '原神5.0纳塔版本正式上线，全新区域、角色和战斗机制全面解析，手把手教你快速上手纳塔版本所有新内容。',
    content: '<p>原神5.0版本「炽烈的还魂诗」正式上线，全新区域<b>纳塔</b>向旅行者敞开大门。本期攻略将从新角色、新地图、新机制三个维度，为大家带来全方位的版本解读。</p><h3>一、新角色详解</h3><p>纳塔版本带来了多位全新可玩角色。首位登场的是五星火元素角色<b>玛薇卡</b>，定位为战场主C，其元素战技可以进入「夜魂加持」状态，大幅提升移动速度和攻击力。元素爆发则能召唤巨大的火焰龙卷，对范围内敌人造成持续火元素伤害。</p><p>推荐武器方面，五星首选专武「炽火之心」，四星可使用「西风长枪」作为过渡。圣遗物方面，推荐「炽烈之魂」四件套，主词条选择攻击沙、火伤杯、暴击头。</p><p>配队推荐：玛薇卡 + 班尼特 + 万叶 + 钟离。班尼特提供攻击力加成和治疗，万叶聚怪减抗，钟离提供护盾保障输出环境。</p><h3>二、纳塔地图探索指南</h3><p>纳塔地区位于提瓦特大陆西部，地形以火山地貌为主。新地图包含三大区域：<b>流焰高地</b>、<b>烬寂峡谷</b>和<b>熔核深渊</b>。每个区域都有独特的解谜机制和隐藏宝箱。</p><p>特别提示：纳塔地区的「烬火之种」收集系统是解锁区域传送点和秘境的关键，建议优先收集。此外，新地图中首次引入了「高温区域」概念，角色在特定区域会持续受到灼烧伤害，需要利用新机制「流火之盾」进行防护。</p><h3>三、新战斗机制解析</h3><p>5.0版本最大的战斗变化是引入了<b>「夜魂」系统</b>。纳塔地区的角色都拥有夜魂能量，在战斗中可以通过特定操作进入夜魂加持状态，获得属性提升和特殊技能。不同角色的夜魂效果各不相同，了解并善用这一系统将极大提升战斗效率。</p><h3>四、版本活动与奖励</h3><p>版本主题活动「炽热的挑战」包含多个小游戏和战斗关卡，完成全部挑战可获得原石、摩拉、经验书等丰富奖励。活动期间每日登录还可领取额外签到奖励，累计登录七天可获得四星武器「焰光之枪」。</p><p>以上就是原神5.0纳塔版本的全部攻略内容，祝各位旅行者在纳塔的冒险之旅中一切顺利！</p>',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Stylized%20Chinese%20gaming%20guide%20illustration%20with%20warm%20orange%20and%20amber%20tones%2C%20clean%20abstract%20background%2C%20fantasy%20game%20elements%2C%20editorial%20design%20aesthetic%2C%20soft%20glow%2C%20modern%20minimal%20composition%2C%20no%20text&width=800&height=450&seq=article-genshin-natlan&orientation=landscape',
    author: '游戏达人小王',
    publishDate: '2026-08-05',
    readTime: '12分钟',
    tags: ['原神', '攻略', '纳塔', '新版本'],
    isFeatured: true,
    gameId: 'game-001',
    gameName: '原神',
  },
  {
    id: 'article-002',
    title: '「黑神话：悟空」全BOSS战攻略：从入门到精通，轻松击败所有妖王',
    slug: 'black-myth-wukong-boss-guide',
    category: '攻略',
    categorySlug: 'guide',
    excerpt: '黑神话悟空全BOSS详细打法攻略，包含每个BOSS的攻击模式分析、最佳应对策略和推荐装备搭配。',
    content: '<p>《黑神话：悟空》以其极具挑战性的BOSS战闻名，许多玩家在部分妖王面前卡关多时。本篇攻略将逐一解析游戏中所有主要BOSS的攻击模式与应对策略。</p><h3>第一章：黑风山</h3><p><b>黑熊精</b>是新手玩家的第一个真正挑战。其攻击模式分为三个阶段：第一阶段以物理爪击为主，侧闪即可躲避；第二阶段会释放黑色旋风，需保持距离；第三阶段进入狂暴状态，攻击频率大幅提升。推荐使用定身术控制后进行爆发输出。</p><p><b>金池长老</b>的战斗场地较小，需注意其召唤的小怪干扰。优先清理小怪，利用场景中的柱子作为掩体躲避远程攻击。</p><h3>第二章：黄风岭</h3><p><b>黄风怪</b>是第二章的守关BOSS，拥有强大的风系法术。关键是在他释放黄风时使用芭蕉扇进行克制，可以打破他的防御姿态，创造输出窗口。</p><h3>第三章：小西天</h3><p><b>黄眉大王</b>的战斗分为室内和室外两个阶段。室内阶段躲避其金铙攻击，室外阶段注意躲避范围AOE。当他释放人种袋时，立刻使用筋斗云远离。</p><h3>第四章：盘丝洞</h3><p><b>蜘蛛精</b>拥有多种控制技能，务必携带解毒丹药。战斗核心是快速打破其召唤的蛛网，避免被限制行动空间。</p><h3>最终BOSS攻略</h3><p>最终战斗考验玩家的综合操作能力。关键点在于完美闪避时机的掌握，以及三种棍法（劈棍、戳棍、立棍）的灵活切换。建议携带足够的回血丹药和增加攻击力的buff道具。</p>',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Stylized%20Chinese%20mythology%20game%20boss%20fight%20illustration%20with%20warm%20amber%20tones%2C%20clean%20abstract%20background%2C%20monkey%20warrior%2C%20editorial%20design%20aesthetic%2C%20soft%20glow%2C%20modern%20minimal%20composition&width=800&height=450&seq=article-wukong-boss&orientation=landscape',
    author: '硬核玩家老李',
    publishDate: '2026-08-03',
    readTime: '15分钟',
    tags: ['黑神话悟空', '攻略', 'BOSS', '单机'],
    isFeatured: true,
    gameId: 'game-005',
    gameName: '黑神话：悟空',
  },
  {
    id: 'article-003',
    title: '王者荣耀S36赛季：强势英雄排行与上分推荐',
    slug: 'honor-of-kings-s36-tier-list',
    category: '排行',
    categorySlug: 'ranking',
    excerpt: '王者荣耀S36赛季最新英雄强度排行，解析当前版本各位置最强英雄，助你快速上分冲王者。',
    content: '<p>王者荣耀S36赛季已经开启两周，经过大量实战数据验证，我们为各位召唤师整理了当前版本各位置的最强英雄排行。</p><h3>对抗路T0</h3><p><b>亚连</b>凭借出色的持续作战能力和灵活的位移，在当前版本对抗路占据统治地位。核心装备「暗影战斧」配合「破军」能打出爆炸伤害。</p><p><b>姬小满</b>的强控和高爆发让她在对抗路也极具竞争力，特别适合针对缺乏位移的英雄。</p><h3>中路T0</h3><p><b>海月</b>的大招幻境机制在团战中依然强势，能够有效分割战场。推荐出装：冷静之靴 + 回响之杖 + 博学者之怒。</p><h3>发育路T0</h3><p><b>戈娅</b>以其超高的机动性和持续输出能力稳居发育路榜首。核心技巧是利用沙舟的漂移机制进行拉扯输出。</p><h3>打野T0</h3><p><b>赵怀真</b>的清野效率和Gank能力在当前版本极为出色。四级后的太极反击机制让他在小规模团战中几乎无敌。</p><h3>游走T0</h3><p><b>朵莉亚</b>作为新一代辅助一姐，其群体治疗和护盾效果在团战中价值极高。大招的净化效果更是克制控制阵容的利器。</p><p>祝各位在S36赛季早日冲上王者！</p>',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Stylized%20mobile%20MOBA%20game%20tier%20list%20illustration%20with%20warm%20orange%20tones%2C%20clean%20abstract%20background%2C%20hero%20game%20elements%2C%20editorial%20design%20aesthetic%2C%20soft%20glow%2C%20modern%20minimal%20composition&width=800&height=450&seq=article-hok-ranking&orientation=landscape',
    author: '电竞观察员阿杰',
    publishDate: '2026-08-01',
    readTime: '8分钟',
    tags: ['王者荣耀', '排行', '攻略', '赛季'],
    isFeatured: true,
    gameId: 'game-002',
    gameName: '王者荣耀',
  },
  {
    id: 'article-004',
    title: '「绝区零」全角色抽取优先级分析与配队推荐',
    slug: 'zenless-zone-zero-character-guide',
    category: '攻略',
    categorySlug: 'guide',
    excerpt: '绝区零公测版本全角色强度评测，告诉你哪些角色值得优先抽取，以及各属性队伍的最佳搭配方案。',
    content: '<p>《绝区零》正式公测以来，角色池不断扩充，许多玩家都在纠结该抽谁、怎么配队。本文将基于实战数据为大家分析角色抽取优先级。</p><h3>S级角色推荐（T0级别）</h3><p><b>艾莲</b>作为冰属性强攻角色，无论是单体爆发还是范围清杂能力都极为出色。她的核心机制「极寒之锋」在叠满buff后能打出惊人的暴击伤害。如果你只能抽一个S级角色，艾莲是最佳选择。</p><p><b>朱鸢</b>是火属性异常角色，擅长给敌人叠加灼烧状态。配合以太属性角色可以触发强力元素反应，高难副本中表现亮眼。</p><h3>A级角色推荐（平民首选）</h3><p><b>安比</b>是性价比最高的A级角色之一，电属性击破定位让她在各类队伍中都能发挥作用。建议每位玩家都练一个安比。</p><h3>配队推荐</h3><p><b>冰队</b>：艾莲（主C）+ 苍角（辅助）+ 冯·莱卡恩（击破）</p><p><b>火队</b>：朱鸢（异常）+ 本（防护）+ 11号（支援）</p><p><b>电队</b>：安比（击破）+ 格莉丝（异常）+ 安东（支援）</p><p>以上配队方案均经过高难副本验证，大家可以根据自己的角色池进行调整。</p>',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Stylized%20urban%20fantasy%20game%20character%20guide%20illustration%20with%20warm%20amber%20tones%2C%20clean%20abstract%20background%2C%20anime%20game%20elements%2C%20editorial%20design%20aesthetic%2C%20soft%20glow%2C%20modern%20minimal&width=800&height=450&seq=article-zzz-character&orientation=landscape',
    author: '游戏达人小王',
    publishDate: '2026-07-28',
    readTime: '10分钟',
    tags: ['绝区零', '攻略', '角色', '配队'],
    isFeatured: false,
    gameId: 'game-004',
    gameName: '绝区零',
  },
  {
    id: 'article-005',
    title: '「崩坏：星穹铁道」2.5版本卡池抽取建议：抽谁最保值？',
    slug: 'honkai-star-rail-25-banner-guide',
    category: '攻略',
    categorySlug: 'guide',
    excerpt: '星穹铁道2.5版本卡池全角色抽取价值分析，结合当前版本环境告诉你哪些角色最值得投入资源。',
    content: '<p>崩坏：星穹铁道2.5版本已经更新，全新五星角色和新剧情内容同步上线。面对有限的星琼资源，该如何做出最优的抽取决策？</p><h3>上半卡池：新五星「飞霄」</h3><p><b>飞霄</b>是风属性巡猎角色，定位为高速单体输出。她的核心机制是通过多次行动叠加「风痕」层数，最终释放高倍率终结技。在忘却之庭等需要单体爆发的场景中表现优异，但面对群怪时略显乏力。</p><p><b>抽取建议</b>：如果你缺少风属性输出角色，飞霄值得抽取。但如果你已经有刃或丹恒·饮月，可以跳过。</p><h3>下半卡池：复刻「阮·梅」</h3><p>阮·梅作为顶级的同谐辅助角色，其全队增伤和弱点击破效率提升能力在当前版本依然强势。如果你还没有阮·梅，<b>强烈建议抽取</b>。她几乎可以融入任何队伍，保值率极高。</p><h3>四星陪跑分析</h3><p>本期四星陪跑包括停云、虎克和佩拉。其中停云是优质的充能辅助，非常值得培养。佩拉的全队减防效果在特定队伍中有奇效。</p><p><b>总结</b>：阮·梅 > 飞霄 > 跳过本版本。资源有限的情况下，优先确保拿到阮·梅。</p>',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Stylized%20sci%20fi%20space%20game%20banner%20guide%20illustration%20with%20warm%20orange%20tones%2C%20clean%20abstract%20background%2C%20cosmic%20game%20elements%2C%20editorial%20aesthetic%2C%20soft%20glow%2C%20modern%20minimal&width=800&height=450&seq=article-hsr-banner&orientation=landscape',
    author: '星穹攻略组',
    publishDate: '2026-07-25',
    readTime: '7分钟',
    tags: ['崩坏星穹铁道', '攻略', '卡池', '抽卡'],
    isFeatured: false,
    gameId: 'game-003',
    gameName: '崩坏：星穹铁道',
  },
  {
    id: 'article-006',
    title: '2026年最值得期待的手游新作TOP 10盘点',
    slug: '2026-most-anticipated-mobile-games',
    category: '排行',
    categorySlug: 'ranking',
    excerpt: '盘点2026年下半年即将上线的十款重磅手游新作，每一款都值得你关注和期待。',
    content: '<p>2026年是手游行业蓬勃发展的一年，众多重量级IP和原创作品都选择在今年下半年上线。我们精选了十款最值得期待的手游新作，快来看看有没有你心仪的作品吧。</p><h3>TOP 1：《无限暖暖》</h3><p>叠纸网络旗下的暖暖系列最新作品，采用开放世界设计，玩家可以在广阔的奇迹大陆上自由探索、搭配服饰、完成任务。画质精美度堪比主机游戏。</p><h3>TOP 2：《明日方舟：终末地》</h3><p>鹰角网络打造的明日方舟衍生作品，从塔防玩法转向3D实时策略战斗，保留了原作深邃的世界观和美术风格。</p><h3>TOP 3：《王者荣耀：世界》</h3><p>腾讯天美基于王者荣耀IP打造的开放世界RPG，玩家将扮演原创角色在王者大陆展开冒险，与熟悉的英雄角色互动。</p><h3>TOP 4：《异环》</h3><p>全新科幻题材开放世界手游，赛博朋克风格的城市设计与高自由度探索玩法令人期待。</p><h3>TOP 5-10</h3><p>还包括《燕云十六声》、《代号56》、《归龙潮》、《望月》、《七日世界》、《百面千相》等多款各具特色的新作。每款游戏都有其独特的玩法和美术风格，建议关注我们的后续深度评测。</p>',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Stylized%20mobile%20games%20ranking%20list%20illustration%20with%20warm%20orange%20tones%2C%20clean%20abstract%20background%2C%20gaming%20elements%20collage%2C%20editorial%20design%20aesthetic%2C%20soft%20glow%2C%20modern%20minimal&width=800&height=450&seq=article-2026-games&orientation=landscape',
    author: '游戏观察员',
    publishDate: '2026-07-20',
    readTime: '6分钟',
    tags: ['手游', '排行', '新作', '2026'],
    isFeatured: false,
    gameId: '',
    gameName: '',
  },
  {
    id: 'article-007',
    title: '「鸣潮」1.3版本深度评测：优化后的体验能否挽回口碑？',
    slug: 'wuthering-waves-13-review',
    category: '评测',
    categorySlug: 'review',
    excerpt: '鸣潮1.3版本带来了大量优化和全新内容，我们将从画面、战斗、剧情、优化四个维度进行全面评测。',
    content: '<p>《鸣潮》自上线以来口碑经历了几番波折。1.3版本作为一次重大更新，能否为这款游戏正名？我们进行了全方位的深度评测。</p><h3>画面表现：9/10</h3><p>鸣潮的视觉表现一直是其最大优势。1.3版本对光影效果进行了进一步优化，新增的「云海群岛」地图场景美轮美奂，天空盒的动态变化效果令人惊艳。角色建模精细度在同类游戏中处于领先水平。</p><h3>战斗系统：8.5/10</h3><p>高速战斗是鸣潮的核心卖点。1.3版本新增了「共鸣连携」系统，让角色之间的技能衔接更加流畅。声骸系统的养成曲线也有所优化，减少了重复刷取的枯燥感。不过高难副本的数值平衡还有调整空间。</p><h3>剧情内容：7.5/10</h3><p>1.3版本的主线剧情质量有明显提升，叙事节奏更加紧凑，角色的塑造也更加立体。支线任务中增加了一些有趣的小游戏玩法，丰富了游戏体验。</p><h3>优化体验：8/10</h3><p>移动端的性能优化是本次更新的重点，中低端机型的帧率稳定性有了显著改善。加载速度、UI响应等方面也有提升。不过耗电量依然偏高，还有优化空间。</p><p><b>总结</b>：1.3版本的鸣潮正在朝着正确的方向前进。如果你曾经因为优化问题弃坑，现在是回归的好时机。</p>',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Stylized%20open%20world%20game%20review%20illustration%20with%20warm%20amber%20tones%2C%20clean%20abstract%20background%2C%20dramatic%20game%20elements%2C%20editorial%20design%20aesthetic%2C%20soft%20glow%2C%20modern%20minimal&width=800&height=450&seq=article-wuwa-review&orientation=landscape',
    author: '硬核玩家老李',
    publishDate: '2026-07-18',
    readTime: '9分钟',
    tags: ['鸣潮', '评测', '版本更新', 'RPG'],
    isFeatured: false,
    gameId: 'game-012',
    gameName: '鸣潮',
  },
  {
    id: 'article-008',
    title: '「蛋仔派对」新手入门到高手进阶完全指南',
    slug: 'eggy-party-beginner-guide',
    category: '攻略',
    categorySlug: 'guide',
    excerpt: '从新手小白到派对大神，这篇蛋仔派对终极攻略包含所有你需要知道的技巧、关卡攻略和进阶操作。',
    content: '<p>《蛋仔派对》以其可爱的画风和欢乐的玩法吸引了数亿玩家。无论你是刚入坑的萌新还是想冲击高段位的老玩家，这篇攻略都能帮到你。</p><h3>基础操作入门</h3><p>蛋仔派对的核心操作包括：<b>滚动</b>（快速移动）、<b>跳跃</b>（跨越障碍）、<b>扑倒</b>（攻击其他蛋仔）、<b>举高高</b>（将其他蛋仔举起并投掷）。熟练使用这四个基础操作是通过大部分关卡的前提。</p><h3>竞速关卡攻略</h3><p>竞速关卡的核心是<b>路线选择</b>。每条赛道通常都有多条可行路线，最短的不一定最快——有些捷径需要精准操作才能通过，新手建议先走安全路线熟悉地图。</p><p>关键技巧：在下坡路段使用滚动可以大幅加速，但转弯时需要提前减速避免掉出赛道。</p><h3>生存关卡攻略</h3><p>生存关卡的目标是在不断缩小的平台上坚持到最后。关键技巧是：占据平台中心位置，利用举高高技能将靠近的敌人抛出场外。注意观察平台裂缝的规律，提前站位。</p><h3>团队关卡攻略</h3><p>团队关卡考验的是协作能力。足球模式中，建议一人守门两人进攻；抢蛋模式中，分工明确比个人英雄主义更有效。</p><h3>进阶技巧</h3><p><b>空中转向</b>：在跳跃过程中可以通过微调方向键改变落地位置，这是高手与普通玩家的分水岭。</p><p><b>边缘抓取</b>：从平台边缘掉落时，可以抓住边缘爬回来。这个技巧在生存关卡中极为重要。</p><p>多加练习，你也能成为派对之王！</p>',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Stylized%20cute%20party%20game%20guide%20illustration%20with%20warm%20orange%20tones%2C%20clean%20abstract%20background%2C%20playful%20game%20elements%2C%20editorial%20design%20aesthetic%2C%20soft%20glow%2C%20modern%20minimal&width=800&height=450&seq=article-eggy-guide&orientation=landscape',
    author: '游戏达人小王',
    publishDate: '2026-07-15',
    readTime: '11分钟',
    tags: ['蛋仔派对', '攻略', '新手', '技巧'],
    isFeatured: false,
    gameId: 'game-007',
    gameName: '蛋仔派对',
  },
];

export const getFeaturedArticles = (): Article[] =>
  articles.filter((a) => a.isFeatured);

export const getLatestArticles = (limit: number = 6): Article[] =>
  [...articles]
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
    .slice(0, limit);

export const getArticleById = (id: string): Article | undefined =>
  articles.find((a) => a.id === id);

export const getArticleBySlug = (slug: string): Article | undefined =>
  articles.find((a) => a.slug === slug);

export const getRelatedArticles = (article: Article, limit: number = 3): Article[] =>
  articles
    .filter((a) => a.id !== article.id && (a.categorySlug === article.categorySlug || a.gameId === article.gameId))
    .slice(0, limit);